<div
  (clickOutside)="close($event)"
  class="slide-y-animation flex flex-col items-center justify-center lg:w-[50dvh] size-full"
>
  <div class="p-4 lg:p-0 lg:w-full">
    <img
      [draggable]="false"
      class="size-full rounded-t-2xl bg-white"
      src="chatbot.png"
    />
    <button
      (click)="close($event)"
      class="bg-zinc-700 text-white rounded-b-2xl hover:bg-zinc-600 transition-all text-center p-2.5 w-full"
    >
      확인
    </button>
  </div>
</div>
